import { render, staticRenderFns } from "./ShipmentItems.vue?vue&type=template&id=43bad590&lang=pug"
import script from "./ShipmentItems.vue?vue&type=script&lang=js"
export * from "./ShipmentItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports